import { InjectionToken } from "@angular/core";

export interface TranslationToken {
    url: string,
    useJsonFiles: boolean
}

export const TRANSLATION_TOKEN = new InjectionToken<TranslationToken>(null);